import userManager from '../utils/userManager'
import React, { Component } from 'react'
import { confirmAlert } from 'react-confirm-alert'
import { LANDINGPAGE, EDITORIALACCESS, CUSTOMERADMINACCESS, CUSTOMERSERVICESACCESS } from '../utils/constants'
import SearchBar from './SearchBar'
import helper from '../utils/helper'
import Iframe from 'react-iframe'

require('../../images/MLex_Logo_Rmark.svg')
require('../../images/MLex-LN-Logo_r.svg')

var ES6Promise = require('es6-promise')
ES6Promise.polyfill()

export class Header extends Component {
  componentDidMount () {
    window.addEventListener('click', function (e) {
      if (e.origin != '') {
        if (!document.getElementById('divMoreContent').contains(e.target)) {
          document.getElementById('liMoreContent').style.backgroundColor = ''
          document.getElementById('divMoreItems').style.display = 'none'
        }
      }
    })
  }

  login () {
    // pass the current path to redirect to the correct page after successfull login
    userManager.signinRedirect({
      data: { path: this.props.path }
    })
  }

  logout (event) {
    if (sessionStorage.getItem('userData') == null) {
      event.preventDefault()
      sessionStorage.removeItem('userData')
      helper.removeSelectedContentFromSession()
      helper.removeContentViewFromSession()
      userManager.signoutRedirect()
      userManager.removeUser()
    } else {
      event.preventDefault()
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className='custom-ui'>
              <h1>Logout</h1>
              <p>Would you like to logout of managing the account for {JSON.parse(sessionStorage.getItem('userData')).name} and close this window?</p>
              <div className='react-confirm-alert-button-group'>
                <button onClick={() => {
                  sessionStorage.removeItem('userData')
                  helper.removeSelectedContentFromSession()
                  helper.removeContentViewFromSession()
                  userManager.removeUser()
                  window.open('', '_self').window.close()
                  if (this.props.userRole == CUSTOMERSERVICESACCESS) {
                    confirmAlert({
                      customUI: ({ onClose }) => {
                        return (
                          <div className='custom-ui-error'>
                            <h1>Logout successful</h1>
                            <p>You may now close this window</p>
                          </div>
                        )
                      },
                      closeOnEscape: false,
                      closeOnClickOutside: false
                    })
                  } else { window.location.assign(process.env.ADMIN_TOOL_USER_URL) }
                }}
                >Yes
                </button>
                <button onClick={() => { onClose() }}>No</button>
              </div>
            </div>
          )
        },
        closeOnEscape: false,
        closeOnClickOutside: false
      })
    }
  }

  goToAdminTool (event) {
    event.preventDefault()
    sessionStorage.removeItem('userData')
    helper.removeSelectedContentFromSession()
    helper.removeContentViewFromSession()
    window.location.assign(`${process.env.ADMIN_TOOL_URL}`)
  }

  toggleDropdown () {
    var liMoreContent = document.getElementById('liMoreContent')
    var divMoreItems = document.getElementById('divMoreItems')

    if (liMoreContent.style.backgroundColor == '') {
      liMoreContent.style.backgroundColor = '#525355'
      divMoreItems.style.display = 'block'
    } else {
      liMoreContent.style.backgroundColor = ''
      divMoreItems.style.display = 'none'
    }
  }

  removeContentsAndViewTypeFromSession () {
    helper.removeSelectedContentFromSession()
    helper.removeContentViewFromSession()
  }

  render () {
    const searchTerm = ''
    const cmsUrl = `${process.env.CMS_URL}`

    return (
      <>
        {sessionStorage.getItem('userData') != null
          ? <header className='impersonate-header content-container'>You are currently managing the MLex account for the user: {JSON.parse(sessionStorage.getItem('userData')).name}</header>
          : null}
        <header className='global-header content-container'>
          <div className={(this.props.path === '/search') ? 'grid-wrapper search' : 'grid-wrapper'}>
            <div className='global-header__left-menu'>
              <a className='logo' href={`/#/${LANDINGPAGE}`} onClick={event => this.removeContentsAndViewTypeFromSession()} aria-label='Mlex Link' title='Go To Home'><img className='logo mlex-logo' src='images/MLex_Logo_Rmark.svg' alt='Mlex Link' /></a>
            </div>
            <div className='global-header__center-menu'>
              <SearchBar id='searchBar' searchTerm={searchTerm} />
            </div>
            <div className='global-header__right-menu'>
              <ul className='global-header-menu'>
                {this.props.userRole == EDITORIALACCESS
                  ? <li>
                    <a title='Go To Editorial' href={cmsUrl} target='_self' rel='noopener noreferrer'>
                      <span className='global-header__text'>Editorial</span>
                    </a>
                  </li>
                  : null}
                <li>
                  <a
                    title='View Alerts' href='/#/personalize' target='_self' rel='noopener noreferrer'
                    onClick={event => this.removeContentsAndViewTypeFromSession()}
                    data-gm-u-pn='content'
                    data-gm-u-c='global_header'
                    data-gm-u-e='alertspage_view'
                    data-gm-u-v='alertspage'
                    data-gm-u-a='click'
                  >
                    <span className='global-header__text'>Alerts</span>
                  </a>
                </li>
                <li>
                  <a
                    title='View Help' href='/#/help' target='_self' rel='noopener noreferrer'
                    onClick={event => this.removeContentsAndViewTypeFromSession()}
                    data-gm-u-pn='content'
                    data-gm-u-c='global_header'
                    data-gm-u-e='helppage_view'
                    data-gm-u-v='help'
                    data-gm-u-a='click'
                  >
                    <span className='global-header__text'>Help</span>
                  </a>
                </li>
                {this.props.isConnected ? (
                  <li id='liMoreContent'>
                    <div title='More' id='divMoreContent' className='more-content' onClick={event => this.toggleDropdown()}>
                      <span className='global-header__icon'></span>
                    </div>
                    <div id='divMoreItems'>
                      <ul>
                        <li>
                          <a
                            title='Conference Listing' href='/#/conference' target='_self' id='aConferenceListing'
                            onClick={event => this.removeContentsAndViewTypeFromSession()}
                            rel='noopener noreferrer'
                            data-gm-u-pn='content'
                            data-gm-u-c='global_header'
                            data-gm-u-e='conferences_viewcalendar'
                            data-gm-u-v='content_conferencespage'
                            data-gm-u-a='click'
                          >
                            <span className='global-header__text'>Conference Listings</span>
                          </a>
                        </li>
                        {((this.props.userRole == CUSTOMERADMINACCESS) && (sessionStorage.getItem('userData') == null))
                          ? <li className='dropdown-user'>
                            <a title='Admin Tool' onClick={event => this.goToAdminTool(event)} href='#' target='_self' rel='noopener noreferrer'>
                              <span className='global-header__text'>User Admin Tool Login</span>
                            </a>
                          </li>
                          : null}
                        <li className='dropdown-user'>
                          <a title='Logout' href='#' target='_self' id='aLogout' rel='noopener noreferrer' onClick={event => this.logout(event)}>
                            <div className='user-profile'>
                              {sessionStorage.getItem('userData') != null
                                ? <>
                                  <span className='global-header__text'>Currently managing user:</span>
                                  <span className='global-header__text'>{JSON.parse(sessionStorage.getItem('userData')).name}</span>
                                  </>
                                : <span className='global-header__text'>{this.props.userName}</span>}
                              <span className='global-header__text'>Logout</span>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                ) : (
                  <li>
                    <a title='Login' href='#' target='_self' rel='noopener noreferrer' onClick={() => this.login()}>
                      {/* <span className='global-header__icon'></span> */}
                      <span className='global-header__text'>Login</span>
                    </a>
                  </li>
                )}

              </ul>
            </div>
          </div>
        </header>
        <header className='print-header'>
        Redistribution authorized in accordance with User Terms in the MLex General Terms of Business. Copyright © {new Date().getFullYear()} MLex Limited
          <img src='/images/MLex-LN-Logo_r.svg' />
        </header>
        <Iframe
          url='/#/home'
          width='640px'
          height='320px'
          id='iframe-search'
          className=''
          display='none'
          position='relative'
        />
      </>

    )
  }
}

export default Header
